import { User } from "./user";
import { Coach } from "./coach";
import { Team } from "./team";
import { Address } from "./address";
import { Guest } from "./guest";
import { Gender } from "./gender";
import { ContractType } from "./contract-type";

interface AthleteData {
  id?: number;
  birthday?: string;
  sportsPracticed?: string;
  clubName?: string;
  description?: string;
  externalCoachName?: string;
  billingEmail?: string;
  weight?: number;
  size?: number;
  lastMood?: string;
  genderId?: number;
  contractTypeId?: number;
  userId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  rights?: string[];

  user?: User;
  coaches?: Coach[];
  guests?: Guest[];
  teams?: Team[];
  addresses?: Address[];
  gender?: Gender;
  contractType?: ContractType;
}

export class Athlete {
  public static getNonTranslatableFields(): string[] { return ['id', 'birthday', 'sportsPracticed', 'clubName', 'description', 'externalCoachName', 'weight', 'size', 'genderId', 'contractTypeId', 'userId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'birthday', 'sportsPracticed', 'clubName', 'description', 'externalCoachName', 'weight', 'size', 'genderId', 'contractTypeId', 'userId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  birthday?: string;
  sportsPracticed?: string;
  clubName?: string;
  description?: string;
  externalCoachName?: string;
  billingEmail?: string;
  weight?: number;
  size?: number;
  lastMood?: string;
  genderId?: number;
  contractTypeId?: number;
  userId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  rights?: string[];

  user?: User;
  coaches?: Coach[];
  guests?: Guest[];
  teams?: Team[];
  addresses?: Address[];
  gender?: Gender;
  contractType?: ContractType;

  public static fromAPI(data: AthleteData): Athlete {
    if (data.user) {
      data.user = User.fromAPI(data.user);
    }
    if (data.coaches) {
      data.coaches = Coach.fromAPIList(data.coaches);
    }
    if (data.guests) {
      data.guests = Guest.fromAPIList(data.guests);
    }
    if (data.teams) {
      data.teams = Team.fromAPIList(data.teams);
    }
    if (data.addresses) {
      data.addresses = Address.fromAPIList(data.addresses);
    }
    if (data.gender) {
      data.gender = Gender.fromAPI(data.gender);
    }
    if (data.contractType) {
      data.contractType = ContractType.fromAPI(data.contractType);
    }
    return new Athlete(data);
  }

  public static fromAPIList(data: AthleteData[]): Athlete[] {
    return data.map((item: AthleteData) => Athlete.fromAPI(item));
  }

  constructor({id, birthday, sportsPracticed, clubName, description, externalCoachName, billingEmail, weight, size, lastMood, genderId,
                contractTypeId, userId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId, rights,
                user, coaches, guests, teams, addresses, gender, contractType} : AthleteData) {
    this.id = id;
    this.birthday = birthday;
    this.sportsPracticed = sportsPracticed;
    this.clubName = clubName;
    this.description = description;
    this.externalCoachName = externalCoachName;
    this.billingEmail = billingEmail;
    this.weight = weight;
    this.size = size;
    this.lastMood = lastMood;
    this.genderId = genderId;
    this.contractTypeId = contractTypeId;
    this.userId = userId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
    this.rights = rights;

    this.user = user;
    this.coaches = coaches;
    this.guests = guests;
    this.teams = teams;
    this.addresses = addresses;
    this.gender = gender;
    this.contractType = contractType;
  }

  public toJson(): Object {
    return {
      id: this.id,
      birthday: this.birthday,
      sportsPracticed: this.sportsPracticed,
      clubName: this.clubName,
      description: this.description,
      externalCoachName: this.externalCoachName,
      billingEmail: this.billingEmail,
      weight: this.weight,
      size: this.size,
      lastMood: this.lastMood,
      genderId: this.genderId,
      contractTypeId: this.contractTypeId,
      userId: this.userId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
